import { useState } from 'react';
import firebase from 'firebase';
import { useNavigate } from 'react-router';
import { useAtom } from 'jotai';
import { auth, db } from '../../../../shared/services/firebase';
import { userRecordAtom } from '../../../../shared/state/atoms';
import { useToast } from '../../../../shared/hooks';
import { useAdminService } from '../../../../shared/services';
import { routeKeys } from '../../../../utils/constants';

export default function useLoginForm() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [, setUserRecord] = useAtom(userRecordAtom);
  const { showError } = useToast();
  const { getAdmin, getStudent } = useAdminService();

  const login = async (email, password) => {
    setIsLoggingIn(true);
  
    try {
      const res = await auth().signInWithEmailAndPassword(email, password);
  
      const user = res?.user;
      const studentRef = db.collection("Students").doc(user.uid);
      const studentDoc = await studentRef.get();
  
      if (studentDoc.exists) {
        const student = studentDoc.data();
        const storedToken = student.SessionToken;
        
        const currentSessionToken = localStorage.getItem("SessionToken");
  
        if (storedToken && storedToken !== currentSessionToken) {
          await firebase.auth().signOut();
          localStorage.removeItem("SessionToken");
          showError("Multiple sessions detected. Cannot login");
          setIsLoggingIn(false);
          return;
        }
  
        if (!storedToken) {
          const newSessionToken = Math.random().toString(36).substring(2);
          await studentRef.update({ SessionToken: newSessionToken });
          localStorage.setItem("SessionToken", newSessionToken);
        }
  
        const studentData = await getStudent(user.uid);
        setUserRecord({
          ...studentData,
          isAdmin: false,
        });
  
        await studentRef.update({
          LastLogin: firebase.firestore.Timestamp.now(),
        });
      } else {
        const admin = await getAdmin(user.uid);
        if (admin) {
          setUserRecord({
            ...admin,
            isAdmin: true,
          });
        } else {
          showError("Error trying to fetch user data.");
          return;
        }
      }
  
      navigate(routeKeys.home, { replace: true });
      setIsLoggingIn(false);
    } catch (error) {
      showError("The email or password that you have entered is incorrect.");
      setIsLoggingIn(false);
    }
  };
  
  

  // const login = (email, password) => {
  //   setIsLoading(true);
  //   auth()
  //     .signInWithEmailAndPassword(email, password)
  //     .then((res) => {

  //       const isAdmin = email === 'deen.joseph@factor6.co.za';

  //       checkAdmin(email);

  //       return db
  //         .collection(isAdmin ? 'Admin' : 'Students')
  //         .doc(res.user.uid)
  //         .get();
  //     })
  //     .then((userDocSnapshot) => {
  //       let userDoc;
  //       if (userDocSnapshot.exists) {
  //         userDoc = userDocSnapshot.data();
  //       } else {
  //         console.error('No user found with this UID in Firestore.');
  //         showError('User does not exist.');
  //       }

  //       const userCollection = userDocSnapshot.ref.parent;
  //       const userDocRef = userCollection.doc(userDocSnapshot.id);
  //       return userDocRef
  //         .update({
  //           LastLogin: new Date(),
  //         })
  //         .then(() => userDoc);
  //     })
  //     .then((userDoc) => {
  //       setUserRecord({ ...userDoc });
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //       showError('The email or password that you have entered is incorrect.');
  //     })
  //     .finally(() => {
  //       if (!error) {
  //         if (admin) navigate(routeKeys.admin + routeKeys.home, { replace: true });
  //         else navigate(routeKeys.myLearning + routeKeys.home, { replace: true });
  //       }
  //       setIsLoading(false);
  //     });
  // };

  const loginWithGoogle = async () => {
    const provider = new auth.GoogleAuthProvider();
    try {
      await auth().signInWithRedirect(provider);
    } catch (error) {
      setError(error);
      showError('An error has occurred when trying to login with Google: ', error);
    }
  };

  return {
    login,
    loginWithGoogle,
    error,
    isLoggingIn,
  };
}
